
import AddPumpingStationHistory from "../components/PumpingStation/AddPumpingStationHistory"
const AddPumpingStationHistoryPage =() =>{
     
    return(
         <AddPumpingStationHistory/>
    )
}

export default AddPumpingStationHistoryPage;